import RSwitch from './RSwitch.vue'

export default RSwitch